import { Component, HostListener } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { ApiServiceService } from '../../services/api-service.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
 showBanner = false;
  showSpecial = false;
  showTopSelling = false;
  constructor(){
    
  }

 
}
